import OrganizationEventTags from "../../../components/Settings/OrganizationEventTags";
import { User } from "../../../store";


interface AnalyticsTabProps {
  subTab?: string;
  user?: User | null;
}

const AnalyticsTab = ({ subTab, user }: AnalyticsTabProps) => {
  const hasAnalyticsLabelsPermission = user?.permissions.ANALYTICS_LABELS;

  if (subTab === 'org' && hasAnalyticsLabelsPermission) {
    return (
      <OrganizationEventTags showAutoAssign={false} />
    );
  }

  return <OrganizationEventTags showLabels={false} />;
};

export default AnalyticsTab;
